import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../component/Header';
import Footer from '../component/Footer';
import SubscriptionSuccessModal from '../component/SubscriptionSuccessModal';

const SubscriptionCheckout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { planName = 'Professional', price = 25 } = location.state || {};

  const [showSuccess, setShowSuccess] = useState(false);

  const subtotal = price;
  const tax = 0;
  const orderTotal = subtotal + tax;

  const formatCurrency = (value) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);

  const handleCheckout = (e) => {
    e.preventDefault();
    setShowSuccess(true);
  };

  return (
    <div className="main subscription-checkout-page full-header">
      <Header />
      <section className="subscription-checkout-section common-padding">
        <Container>
          <Form onSubmit={handleCheckout}>
            <Row className="g-4">
              <Col lg={7}>
                <div className="payment-method-box">
                  <h3 className="section-title">Choose Payment Method</h3>
                  <p className="section-subtitle">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                  </p>

                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>First Name <span>*</span></Form.Label>
                        <Form.Control type="text" placeholder="Enter First Name" required />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Last Name <span>*</span></Form.Label>
                        <Form.Control type="text" placeholder="Enter Last Name" required />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Mobile Number <span>*</span></Form.Label>
                        <Form.Control type="tel" placeholder="Enter Mobile Number" required />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Email Address <span>*</span></Form.Label>
                        <Form.Control type="email" placeholder="Enter Email Address" required />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Mobile Wallet <span>*</span></Form.Label>
                        <Form.Select required defaultValue="mpesa">
                          <option value="mpesa">M-Pesa</option>
                          <option value="airtel">Airtel Money</option>
                          <option value="bank">Bank Transfer</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={5}>
                <div className="order-summary-box">
                  <h3 className="section-title">Order Summary</h3>

                  <div className="order-plan-grid">
                    <div className="order-plan-col">
                      <span className="label">Plan</span>
                      <span className="value">{planName}</span>
                    </div>
                    <div className="order-plan-col">
                      <span className="label">Billing</span>
                      <span className="value">Monthly</span>
                    </div>
                    <div className="order-plan-col">
                      <span className="label">Amount</span>
                      <span className="value">${price}</span>
                    </div>
                  </div>

                  <div className="order-totals">
                    <div className="order-row">
                      <span>Subtotal</span>
                      <span>{formatCurrency(subtotal)}</span>
                    </div>
                    <div className="order-row">
                      <span>Tax</span>
                      <span>{formatCurrency(tax)}</span>
                    </div>
                    <div className="order-row order-total">
                      <span>Order Total</span>
                      <span>{formatCurrency(orderTotal)}</span>
                    </div>
                  </div>

                  <div className="order-actions">
                    <Button
                      type="button"
                      className="custom-bttn style-2"
                      onClick={() => navigate('/subscription')}
                    >
                      Back to Plan
                    </Button>
                    <Button type="submit" className="custom-bttn">
                      Continue
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>
      <Footer />

      <SubscriptionSuccessModal
        show={showSuccess}
        planName={planName}
        handleClose={() => setShowSuccess(false)}
      />
    </div>
  );
};

export default SubscriptionCheckout;
